import type { ConnectFormProps } from './types';

const getBaseUrl = (form: ConnectFormProps) => {
  return form.use_dev_url
    ? 'https://storage.googleapis.com/dev-ai-agents-web-widgets/widgets'
    : 'https://uat-cdn.nextlevel.ai/widgets';
};

const getWidgetType = (form: ConnectFormProps) => {
  return form.use_video_avatar
    ? 'fullscreen_video.html'
    : 'ai_conference_call.html';
};

export const createWidgetHostUrl = (form: ConnectFormProps): string => {
  if (form.override_url?.trim()) return form.override_url;

  const baseUrl = `${getBaseUrl(form)}/${getWidgetType(form)}`;
  const params = new URLSearchParams({ agentId: form.agent_id });
  form.use_dev_agent && params.append('useDev', 'true');

  const { bg_info_id, knowledgeBaseId, presentation_id } = form;
  bg_info_id && params.append('bg_info_id', bg_info_id);
  presentation_id && params.append('presentation_id', presentation_id);
  knowledgeBaseId && params.append('knowledgeBaseId', knowledgeBaseId);

  return `${baseUrl}?${params.toString()}`;
};
